'use client';

import { WithdrawCancelIllustration } from '@/components/atoms/WithdrawCancelIllustration';

export const GameDayCancelled = () => {
	return (
		<div className="flex w-full flex-col items-center justify-center pt-10">
			<div className="flex sm:min-w-[500px] flex-col items-center justify-center rounded-2xl border border-solid bg-orange-50 border-orange-700 p-4">
				<h1 className="text-lg sm:text-2xl font-semibold text-darkorange-600 text-wrap">This Game Day has been canceled.</h1>
			</div>

			<div className="mt-2">
				<WithdrawCancelIllustration />
			</div>
		</div>
	);
};
